import { NEW_PATH_DELIMITER } from '@picsio/db/src/constants';

export default function getGroups(all) {
  const team = [];
  const personal = [];

  all.forEach((item) => {
    const {
      path, teamId, readonly, dynamic, isGroupPlaceholder,
    } = item;
    if (!path || readonly || dynamic) return;

    const splittedPath = path.split(NEW_PATH_DELIMITER);
    // Saved-search paths are `…${DELIM}<name>`; the last segment is the item
    // name. Empty-group docs use `path` as the group path itself
    // (`isGroupPlaceholder`), so dropping the final segment would hide those
    // groups from move-target discovery (see SavedSearchesTree Item).
    if (!isGroupPlaceholder) splittedPath.pop();

    // maket groups from paths, '/a/b/c/d' => ['/a', '/a/b', '/a/b/c']
    const groupsFromPath = [];

    splittedPath.reduce((acc, part) => {
      if (!part) return acc;
      const groupPath = acc ? `${acc}${NEW_PATH_DELIMITER}${part}` : `${NEW_PATH_DELIMITER}${part}`;
      groupsFromPath.push(groupPath);
      return groupPath;
    }, '');

    if (teamId) {
      team.push(...groupsFromPath);
    } else {
      personal.push(...groupsFromPath);
    }
  });

  return {
    team: [...new Set(team.filter(Boolean))],
    personal: [...new Set(personal.filter(Boolean))],
  };
}
